export const APP_NAME = 'FlowQMS';

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1536,
} as const;

export const Z_INDEX = {
  BASE: 0,
  STICKY: 10,
  SIDEBAR: 20,
  DROPDOWN: 30,
  DRAWER: 40,
  MODAL_BACKDROP: 45,
  MODAL: 50,
  TOAST: 60,
  TOOLTIP: 70,
  COMMAND_PALETTE: 80,
} as const;

export const PAGINATION_DEFAULTS = {
  PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const FILE_LIMITS = {
  MAX_FILE_SIZE_MB: 10,
  MAX_LOGO_SIZE_MB: 2,
  ALLOWED_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/png',
    'image/jpeg',
    'text/csv',
  ],
  ALLOWED_EXTENSIONS: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'csv'],
} as const;

export const ISO_CLAUSES = [
  '4.1', '4.2', '4.3', '4.4',
  '5.1', '5.2', '5.3',
  '6.1', '6.2', '6.3',
  '7.1', '7.2', '7.3', '7.4', '7.5',
  '8.1', '8.2', '8.3', '8.4', '8.5', '8.6', '8.7',
  '9.1', '9.2', '9.3',
  '10.1', '10.2', '10.3',
] as const;

export const IMPORT_LIMITS = {
  MAX_ROWS: 1000,
  BATCH_SIZE: 50,
  MAX_ERRORS_STORED: 100,
  SOURCE_FILE_RETENTION_DAYS: 30,
} as const;

export const QUERY_CONFIG = {
  STALE_TIME: 30_000,
  GC_TIME: 5 * 60_000,
  RETRY_MAX: 3,
  RETRY_DELAY_BASE: 1000,
  RETRY_DELAY_MAX: 30_000,
} as const;
